import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PasswordValidators } from '../../../../shared/components/validators/password.validators';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { MatButtonModule } from '@angular/material/button';
import { InputField } from '../../../../shared/components/input-field/input-field';

@Component({
  selector: 'app-change-password-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    InputField,
  ],
  templateUrl: './change-password-dialog.component.html',
  styleUrl: './change-password-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePasswordDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ChangePasswordDialogComponent>);

  readonly data = inject<DialogData>(MAT_DIALOG_DATA);

  private fb = inject(FormBuilder);

  form = this.fb.nonNullable.group(
    {
      password: [
        '',
        [
          PasswordValidators.required(),
          PasswordValidators.complexity(),
          PasswordValidators.allowedCharacters(),
          PasswordValidators.minLength(),
          PasswordValidators.maxLength(),
        ],
      ],
      passwordConf: ['', [PasswordValidators.required()]],
    },
    {
      validators: [PasswordValidators.match('password', 'passwordConf')],
    },
  );

  submit(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.getRawValue());
  }

  close(): void {
    this.dialogRef.close();
  }
}
